import * as React from "react";
import { createLabels } from "@dazn/fe-labels";
const labels = createLabels({
    resourceStrings: {},
});
export const LabelsContext = React.createContext({
    labels,
    visibilityTreshold: 0,
    visibilityTrigger: "intersectionObserver",
});
//# sourceMappingURL=LabelsContext.js.map